import React from 'react';
import styled from '@emotion/styled';
import {
  Route,
  Switch,
  useRouteMatch,
  useLocation,
} from 'react-router-dom';
import { useSelector } from 'react-redux';

import DuplicateErrorContainer from './DuplicateErrorContainer';
import EasyJoinConfirmationContainer from './EasyJoinConfirmationContainer';
import EasyJoinFormContainer from './EasyJoinFormContainer';
import RegistrationFormContainer from './RegistrationFormContainer';
import Spinner from '../../../../shared/_TBComponents/Spinner';

const ContentWrapper = styled('div')`
  align-self: ${(props) => (props.pathname === '/signup/registration' ? '' : 'center')};
  height: auto;
  width: 100%;
  z-index: 1000;
  display: flex;
  justify-content: center;
`;

const SpinnerContainer = styled('div')`
  background-color: #FFFFFF;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  height: auto;
  padding: 60px 48px;
  position: relative;
  width: 440px;

  @media screen and (max-width: 768px) {
    padding: 40px 32px;
    width: 100%;
    max-width: 440px;
  }

  @media screen and (max-width: 425px) {
    padding: 32px 24px;
    width: 100%;
    max-width: 100%;
  }
`;

const RegistrationContainer = () => {
  const { path } = useRouteMatch();
  const { pathname } = useLocation();
  const currentUser = useSelector((state) => state.auth.data.currentUser);

  // If user becomes registered while on the registration page, show spinner
  // to prevent 404 flash while LoginRoute redirect happens
  const isRegisteredOnRegistrationPage = currentUser
    && Object.keys(currentUser).length > 0
    && currentUser.isRegistered === true
    && pathname === '/signup/registration';

  if (isRegisteredOnRegistrationPage) {
    return (
      <ContentWrapper>
        <SpinnerContainer>
          <Spinner />
        </SpinnerContainer>
      </ContentWrapper>
    );
  }

  return (
    <ContentWrapper pathname={pathname}>
      <Switch>
        <Route
          path={`${path}/duplicate-error`}
        >
          <DuplicateErrorContainer />
        </Route>
        <Route
          path={`${path}/easy-join`}
        >
          <EasyJoinFormContainer />
        </Route>
        <Route
          path={`${path}/easy-join-confirmation`}
        >
          <EasyJoinConfirmationContainer />
        </Route>
        <Route
          path={`${path}/registration`}
        >
          <RegistrationFormContainer />
        </Route>
      </Switch>
    </ContentWrapper>
  );
};

export default RegistrationContainer;
